import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './Auth/AuthContext';

import Sidebar from './components/sidebar/Sidebar';
import ProtectedRoutes from './Auth/ProtectRoutes';
import { Redirect } from './components/Redirect';

import Dashboard from './pages/Dashboard';
import Culture from './pages/Culture/Culture';
import Engage from './pages/Engage/Engage';
import Develop from './pages/Develop/Develop';
import Grow from './pages/Grow/Grow';
import Reward from './pages/Reward/Reward';
import PerformanceContract from './pages/PerformanceContract/PerformanceContract';
import PerformanceDashboard from './pages/PerformanceDistribution/PerformanceDistribution';
import PerformanceDistribution from './pages/PerformanceDistribution/PerformanceDistribution';
import ProgressDashboard from './pages/ProgressDashboard/ProgressDashboard';
import PerformanceContractForm from './pages/PerformanceContract/PerformanceContractForm';
import HelpSupport from "./pages/HelpSupport/HelpSupport";
import IssueLogForm from './pages/IssueLog/IssueLogForm';
import IssueLogs from './pages/IssueLog/IssueLog';
import PerformanceContractFormIndividual from "./pages/PerformanceContract/PerformanceContractFormIndividual";
import PerformanceContractPrior from "./pages/PerformanceContract/PerformanceContractPrior";
import ThreeSixtyReview from "./pages/Three60/ThreeSixtyReview";
import ThreeSixtyReviewFeedback from "./pages/Three60/ThreeSixtyReviewFeedback";
//import EmployeeProfile from "./pages/EmployeeProfile/EmployeeProfile";

// Optional: a minimal Login page (if you don't already have it)
import Login from './pages/Login';
import GoalSettings from "./pages/GoalSettings/GoalSettings";
import ContractsIndex from "./pages/Contracts/ContractsIndex";
import MyIdp from "./pages/IDP/MyIdp";
import TeamIdps from "./pages/IDP/TeamIdps";
import EmployeeIdps from "./pages/IDP/EmployeeIdps";
import MyPerformanceReviews from "./pages/Reviews/MyPerformanceReviews";
import TeamPerformanceReviews from "./pages/Reviews/TeamPerformanceReviews";
import TeamPerformanceReviewsIndex from "./pages/Reviews/TeamPerformanceReviewsIndex";
import TeamPerformanceReviewsEmployee from "./pages/Reviews/TeamPerformanceReviewsEmployee"; // use the Bootstrap login from earlier


import EmployeeProfile from './pages/EmployeeProfiles/EmployeeProfile';
import EmployeeProfilesIndex from './pages/EmployeeProfiles/EmployeeProfilesIndex';
import EmployeeProfileTeamView from './pages/EmployeeProfiles/EmployeeProfileTeamView';


// Layout that includes Sidebar only for authed users
const ProtectedShell = ({ children }) => {
  const { status } = useAuth();
  return (
      <>
        {status === 'authenticated' && <Sidebar />}
        {children}
      </>
  );
};

const AppRoutes = () => (
    <Routes>
      {/* public login; redirect away if already authed */}
      <Route
          path="/login"
          element={
            <Redirect>
              <Login />
            </Redirect>
          }
      />

      {/* protected area */}
      <Route
          path="/"
          element={
            <ProtectedRoutes>
              <ProtectedShell>
                <Dashboard />
              </ProtectedShell>
            </ProtectedRoutes>
          }
      />

      <Route
          path="/culture"
          element={
            <ProtectedRoutes>
              <ProtectedShell><Culture /></ProtectedShell>
            </ProtectedRoutes>
          }
      />
      <Route
          path="/engage"
          element={
            <ProtectedRoutes>
              <ProtectedShell><Engage /></ProtectedShell>
            </ProtectedRoutes>
          }
      />
      <Route
          path="/learn"
          element={
            <ProtectedRoutes>
              <ProtectedShell><Develop /></ProtectedShell>
            </ProtectedRoutes>
          }
      />
      <Route
          path="/grow"
          element={
            <ProtectedRoutes>
              <ProtectedShell><Grow /></ProtectedShell>
            </ProtectedRoutes>
          }
      />
      <Route
          path="/reward"
          element={
            <ProtectedRoutes>
              <ProtectedShell><Reward /></ProtectedShell>
            </ProtectedRoutes>
          }
      />

      <Route
          path="/performance-contract"
          element={
            <ProtectedRoutes>
              <ProtectedShell><PerformanceContract /></ProtectedShell>
            </ProtectedRoutes>
          }
      />

      <Route
          path="/three-sixty-review"
          element={
            <ProtectedRoutes>
              <ProtectedShell><ThreeSixtyReview /></ProtectedShell>
            </ProtectedRoutes>
          }
      />
      <Route
          path="/three-sixty-review-feedback"
          element={
            <ProtectedRoutes>
              <ProtectedShell><ThreeSixtyReviewFeedback /></ProtectedShell>
            </ProtectedRoutes>
          }
      />
      <Route
          path="/employee-profile"
          element={
            <ProtectedRoutes>
              <ProtectedShell><EmployeeProfile /></ProtectedShell>
            </ProtectedRoutes>
          }
      />

      <Route
          path="/performance-contract/:id"
          element={
            <ProtectedRoutes>
              <ProtectedShell><PerformanceContractForm /></ProtectedShell>
            </ProtectedRoutes>
          }
      />
      <Route
          path="/performance-contract/self/:id"
          element={
            <ProtectedRoutes>
              <ProtectedShell><PerformanceContractFormIndividual /></ProtectedShell>
            </ProtectedRoutes>
          }
      />
      <Route
          path="/2022-review-cycle"
          element={
            <ProtectedRoutes>
              <ProtectedShell><PerformanceContractPrior /></ProtectedShell>
            </ProtectedRoutes>
          }
      />
      <Route
          path="/performance-dashboard"
          element={
            <ProtectedRoutes>
              <ProtectedShell><PerformanceDashboard /></ProtectedShell>
            </ProtectedRoutes>
          }
      />
      <Route
          path="/performance-distribution"
          element={
            <ProtectedRoutes>
              <ProtectedShell><PerformanceDistribution /></ProtectedShell>
            </ProtectedRoutes>
          }
      />
      <Route
          path="/progress-dashboard"
          element={
            <ProtectedRoutes>
              <ProtectedShell><ProgressDashboard /></ProtectedShell>
            </ProtectedRoutes>
          }
      />
      <Route
          path="/help-support"
          element={
            <ProtectedRoutes>
              <ProtectedShell><HelpSupport /></ProtectedShell>
            </ProtectedRoutes>
          }
      />
      <Route
          path="/issue-logs"
          element={
            <ProtectedRoutes>
              <ProtectedShell><IssueLogs /></ProtectedShell>
            </ProtectedRoutes>
          }
      />
      <Route
          path="/issue-logs/add"
          element={
            <ProtectedRoutes>
              <ProtectedShell><IssueLogForm /></ProtectedShell>
            </ProtectedRoutes>
          }
      />
      <Route
          path="/issue-logs/:id"
          element={
            <ProtectedRoutes>
              <ProtectedShell><IssueLogForm /></ProtectedShell>
            </ProtectedRoutes>
          }
      />

      <Route
          path="/goal-settings"
          element={
            <ProtectedRoutes>
              <ProtectedShell><GoalSettings /></ProtectedShell>
            </ProtectedRoutes>
          }
      />

      <Route
          path="/contracts/:contractId"
          element={
            <ProtectedRoutes>
              <ProtectedShell><GoalSettings /></ProtectedShell>
            </ProtectedRoutes>
          }
      />

      <Route
          path="/contracts/mine"
          element={
            <ProtectedRoutes>
              <ProtectedShell><GoalSettings /></ProtectedShell>
            </ProtectedRoutes>
          }
      />

        <Route
            path="/contracts"
            element={
                <ProtectedRoutes>
                    <ProtectedShell><ContractsIndex /></ProtectedShell>
                </ProtectedRoutes>
            }
        />


        <Route
            path="/idp/mine"
            element={
                <ProtectedRoutes>
                    <ProtectedShell><MyIdp /></ProtectedShell>
                </ProtectedRoutes>
            }
        />
        <Route
            path="/idp/contract/:contractId"
            element={
                <ProtectedRoutes>
                    <ProtectedShell><EmployeeIdps /></ProtectedShell>
                </ProtectedRoutes>
            }
        />
        <Route
            path="/idp/managed"
            element={
                <ProtectedRoutes>
                    <ProtectedShell><TeamIdps /></ProtectedShell>
                </ProtectedRoutes>
            }
        />
        <Route
            path="/reviews/mine"
            element={
                <ProtectedRoutes>
                    <ProtectedShell><MyPerformanceReviews /></ProtectedShell>
                </ProtectedRoutes>
            }
        />

        <Route
            path="/reviews/managed"
            element={
                <ProtectedRoutes>
                    <ProtectedShell><TeamPerformanceReviews /></ProtectedShell>
                </ProtectedRoutes>
            }
        />
        <Route
            path="/reviews/team"
            element={
                <ProtectedRoutes>
                    <ProtectedShell><TeamPerformanceReviewsIndex /></ProtectedShell>
                </ProtectedRoutes>
            }
        />
        <Route
            path="/reviews/team/:employeeId"
            element={
                <ProtectedRoutes>
                    <ProtectedShell><TeamPerformanceReviewsEmployee /></ProtectedShell>
                </ProtectedRoutes>
            }
        />

        <Route path="/employee-profile"
               element={
                   <ProtectedRoutes>
                       <ProtectedShell><EmployeeProfile /></ProtectedShell>
                   </ProtectedRoutes>
               }
        />
        <Route path="/employee-profiles"
               element={
                   <ProtectedRoutes>
                       <ProtectedShell><EmployeeProfilesIndex /></ProtectedShell>
                   </ProtectedRoutes>
               }
        />
        <Route path="/employee-profiles/:userId"
               element={
                   <ProtectedRoutes>
                       <ProtectedShell><EmployeeProfileTeamView /></ProtectedShell>
                   </ProtectedRoutes>
               }
        />

      {/* 404 */}
      <Route path="*" element={<div className="container py-5"><h1 className="h4">Page not found</h1></div>} />



    </Routes>
);

const App = () => (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
);

export default App;
